import React from "react";

import "./Skeletons.css";

interface FormControlLabelSkeletonProps {
	control: React.ReactNode;
}

export const FieldSkeleton: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="skeleton field-skeleton">{children}</div>;

export const LabelSkeleton: React.FunctionComponent = () => (
	<div className="skeleton label-skeleton" />
);

export const SelectSkeleton: React.FunctionComponent = () => (
	<div className="skeleton-shine select-skeleton" />
);

export const FormControlLabelSkeleton: React.FunctionComponent<
	FormControlLabelSkeletonProps
> = ({ control }) => (
	<div className="skeleton-shine form-control-label-skeleton">
		<div className="form-control-label-skeleton--control">{control}</div>
		<div className=" form-control-label-skeleton--label" />
	</div>
);

export const RadioSkeleton: React.FunctionComponent = () => (
	<div className="skeleton radio-skeleton" />
);
